export default class StringUtils {
  /**
   * 数値かどうかを判断する
   * @param {string} target 対象文字列
   * @return {boolean} true: 数値、false: 数値以外
   */
  public static isNumber(target: string): boolean {
    const val = parseInt(target);
    if (isNaN(val)) {
      return false;
    }
    return true;
  }

  /**
   * 半角カナ文字チェック
   * @param {string} target 対象文字列
   * @return {boolean} true: 半角カナあり、false: 半角カナなし
   */
  public static isHankakuKana(target: string): boolean {
    for (const char of Array.from(target)) {
      if (char.match(/^[ｦ-ﾟ]*$/)) {
        return true;
      }
    }
    return false;
  }

  /**
   * 半角文字チェック
   * @param {string} target
   * @return {boolean} true: 半角あり、false: 半角なし
   */
  public static isHankaku(target: string): boolean {
    for (const char of Array.from(target)) {
      if (char.match(/^[A-Za-z0-9]*$/)) {
        return true;
      }
    }
    return false;
  }
}
